import React from 'react';
import { GlobalLoaderProps } from './types';
import styles from './styles.module.scss';

const GlobalLoader: React.FC<GlobalLoaderProps> = ({ isLoading }) =>
  isLoading ? <div className={styles.container} /> : null;

export default GlobalLoader;
